import { ThemeProvider } from 'styled-components';
import { theme } from 'cdk-radial';
import { RadialTheme } from '../types';

interface IRadialProvider {
  children: React.ReactNode;
}
const RadialProvider = ({ children }: IRadialProvider): JSX.Element => (
  <ThemeProvider theme={theme as RadialTheme}>{children}</ThemeProvider>
);

export default RadialProvider;
